import { Box, Card, Typography } from "@mui/material";
import { Carousel } from "react-responsive-carousel";
import { BIBlue, BIGrey } from "../../assets/helpers";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { English } from "../../constant/EnglishFallback";
import { useSelector } from "react-redux";
import defaultProjectImage from "../../assets/images/image-unavailable.jpg";


export default function AdsCarousel({ adsData }) {
  const navigate = useNavigate();

  const { multiLanguageData } = useSelector((state) => state?.main);

  const LanguageData = multiLanguageData?.DashBoard || {};
  const { TEXT_WHATS_NEW = English.DashBoard.TEXT_WHATS_NEW } = LanguageData || {};

  const [activeSlide, setActiveSlide] = useState(0);

  const handleSlideChange = (index) => {
    setActiveSlide(index);
  };

  function handleAdClick(clickFrom) {
    switch (clickFrom) {
      case "tickets":
      case "Tickets":
        navigate("/tickets");
        break;
      case "MySites":
      case "MySites1":
      case "Sites":
      case "sites":
        navigate("/sites");
        break;
      case "Quiz":
        navigate("/reward-store/earn-builderbucks/");
        // navigate("/reward-store/earn-builderbucks/earn-rewards/");
        break;
      case "Carpool":
        navigate("/carpool/");
        break;
      case "Expenses":
        navigate("/expenses");
        break;
      case "RewardStore":
        navigate("/reward-store/");
        break;
      case "https://mybuilderid.com/":
        window.open(clickFrom, "_blank");
        break;
      default:
        if (clickFrom) {
          const url =
            clickFrom.startsWith("http://") || clickFrom.startsWith("https://")
              ? clickFrom
              : `https://${clickFrom}`;
          window.open(url, "_blank");
        }
        break;
    }
  }

  return (
    <Card className="pagelist-content">
      <Typography sx={{ textAlign: "center", mt: 1, fontWeight: "500" }}>
        {TEXT_WHATS_NEW}
      </Typography>
      <Box sx={{ p: 2, textAlign: "center" }}>
        <Box
          sx={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}></Box>
        <Carousel
          showThumbs={false}
          showArrows={false}
          showIndicators={adsData?.length === 0 ? false : true}
          autoFocus={true}
          swipeable={true}
          emulateTouch={true}
          useKeyboardArrows={true}
          showStatus={false}
          infiniteLoop={true}
          dynamicHeight={false}
          autoPlay={true}
          interval={2000}
          width="100%"
          selectedItem={activeSlide}
          onChange={handleSlideChange}
          renderIndicator={(onClickHandler, isSelected, index, label) => {
            const style = {
              width: "8px",
              height: "8px",
              margin: "0 5px",
              background: isSelected ? BIBlue : BIGrey,
              borderRadius: "50%",
              cursor: "pointer",
              display: "inline-block",
              textAlign: "center",
              marginTop: "10px"
            };
            return (
              <li
                style={style}
                onClick={onClickHandler}
                onKeyDown={onClickHandler}
                value={index}
                key={index}
                role="button"
                tabIndex={0}
                title={`${label} ${index + 1}`}
              />
            );
          }}>
          {adsData?.map((item, index) => (
            <div
              key={index}
              className="taketour-image-section"
              style={{ cursor: "pointer" }}
              onClick={() => handleAdClick(item?.redirectUrl)}>
              <img
                src={item?.fileUrl}
                alt={`Ad ${index + 1}`}
                onError={(e) => {
                  e.target.src = defaultProjectImage;
                }}
              />
            </div>
          ))}
        </Carousel>
      </Box>
    </Card>
  );
}
